import {Component, Input, NgModule, OnInit, Output} from '@angular/core';
import {NewsletterService} from "../../../shared/services/newsletter.service";
import {SettlementTemplate} from "../../../shared/interface/settlement-template";
import {Newsletter} from "../../../shared/interface/newsletter";

@Component({
  selector: 'app-newsletter-current',
  templateUrl: './newsletter-current.component.html',
  styleUrls: ['./newsletter-current.component.scss'],
})


export class NewsletterCurrentComponent implements OnInit {
  @Input() disableBreadcrumb = false;

  pdfSrc = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
  currentNewsletterObject: Newsletter;
  zoom  = 'page-fit';
  constructor(
      private newsletterService: NewsletterService
  ) { }

  ngOnInit(): void {
    this.initialize();
  }
  initialize(): void {
    this.newsletterService.getCurrent()
        .subscribe((newsletter: Newsletter) => {
          this.currentNewsletterObject = newsletter;
        });
  }


}
